export enum LoadingState {
  None = 0,
  Loading = 1,
  Loaded = 2,
  Updating = 3,
  Updated = 4,
}
